/* eslint-disable no-underscore-dangle */
/* eslint-disable max-len */
import React, { useState,useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import './index.css';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { Link, useParams } from 'react-router-dom';
import CustomerContainer from './CustomerContainer';
import ThankReviews from '../Reviews/ThankReviews';
import StarRating from './StarRating';
import Loader from '../Loader';
import Header from '../Header';
import WriteExperience from './WriteExperience';
import righticon from '../../assests/checkmark.png';
import facebook from '../../assests/facebook.png';
import google from '../../assests/google.png';

const starChipClass = [
  'group flex min-w-0 flex-1 cursor-pointer select-none flex-col items-center justify-center gap-1',
  'rounded-xl border border-slate-200 bg-white px-1 py-3 text-center text-xs leading-tight',
  'shadow-sm transition duration-200 hover:scale-105 hover:border-current hover:shadow-md active:scale-95',
  'sm:max-w-[104px] sm:text-sm',
].join(' ');

function CustomerExperience({ baseURL }) {
  const { id } = useParams();

  const [experienceGetData,setExperienceGetData] = useState(null);
  const [gotData, setGotData] = useState(false);
  const [page, setPage] = useState(1);
  const [rateValue, setRateValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [name, setName] = useState('');
  const [number, setphoneNuumber] = useState('');

  useEffect(() => {
    ExperinceApiHandler();
  },[]);

  const ExperinceApiHandler = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseURL}/company/get-cx-review-links/${id}`,{
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',         
        },
      });
      if (response.data.status === 'success') {
        setGotData(response?.data?.status);
        setExperienceGetData(response?.data?.data);
        setLoading(false);
      }
      const body = {
        type: 'scanned',
        qr_type: 'cx',
      };
      if (localStorage.getItem('scanned') === null) {
        const res = await axios.put(`${baseURL}/company/update-qr-code/${id}`,body);
      }
      localStorage.setItem('scanned', 'true');
    } catch (error) {
      console.log(error,'error');
    }
  };

  if (loading) {
    return <Loader />;
  }
  const openHandler = (value) => {
    setRateValue(value);
    if (experienceGetData?.all_null === true) {
      setPage(3);
      return;
    }
    if (value === 4 || value === 5) {
      if (experienceGetData?.only_one !== null) {
        window.open(experienceGetData?.only_one, '_self');
        return;
      }
      setPage(2);
    } else if (value < 4) {
      setPage(3);
    }
  };
  const handleReviewActivity = async (value,type) => {
    // console.log('value',value);
    const body = {
      type: 'clicked',
      qr_type: 'cx',
    };
    if (localStorage.getItem('clicked') === null) {
      const res = await axios.put(`${baseURL}/company/update-qr-code/${id}`,body);
      localStorage.setItem('clicked', 'true');
    }
    if (type === 'facebook_type') {
      window.open(value, '_self');
    }
    if (type === 'google_type') {
      window.open(value, '_self');
    }
    if (type === 'yelp_type') {
      window.open(value, '_self');
    }
  };
  const SendReview = async () => {
    const fromdata = {
      phone: number,
      email: null,
      value: rateValue,
      message,
      name,
    };
    const res = await axios.post(`${baseURL}/testing/create-cx-contact/${id}`,fromdata);
    if (res.data.status === 'success') {
      setPage(4);
    } else {
      toast.error(res.data.message);
    }
    const body = {
      type: 'clicked',
      qr_type: 'cx',
    };
    if (localStorage.getItem('clicked') === null) {
      const response = axios.put(`${baseURL}/company/update-qr-code/${id}`,body);
      localStorage.setItem('clicked', 'true');
    }
  };

  return (
    <div className="qs-page">
      <div className="qs-card min-h-[500px]">
        <Header 
          logo={experienceGetData?.company_logo}
          headerColor={experienceGetData?.display?.email_header_color}
          headerTextColor={experienceGetData?.display?.email_header_text_color}
          companyName={experienceGetData?.name}
          // eslint-disable-next-line no-unsafe-optional-chaining
          ratingValue={(experienceGetData?.rating_average === null ? null : Number(Math.round((experienceGetData?.rating_average) * 10) / 10))}
          reviewCount={experienceGetData?.review_count}
        />
        <div className="qs-card-body flex-1">
          {page === 1 && (
            <div className="qs-fade-in">
              <div className="space-y-4">
                <div className="qs-subtitle flex justify-center">
                  <span>Thank you for choosing us! Please take a moment to leave us a review. Your responses will help us serve you better in the future.</span>
                </div>
                <div className="qs-title flex justify-center">
                  How likely are you to recommend us to a friend or colleague?
                </div>
              </div>
        
              <div className="mt-8">
              
                <div>
                  <div className="mt-6">
                    <div className="flex justify-center gap-1.5 sm:gap-3">
                      <div className={`${starChipClass} text-red-600`} onClick={() => openHandler(1)}>
                        <StarOutlineIcon className="!text-4xl cursor-pointer transition-transform duration-200 group-hover:scale-110" />
                        <div>
                          Hated it
                        </div> 
                      </div>

                      <div className={`${starChipClass} text-orange-600`} onClick={() => openHandler(2)}>
                        <StarOutlineIcon className="!text-4xl cursor-pointer transition-transform duration-200 group-hover:scale-110" />
                        <div>
                          Good
                        </div> 
                      </div>

                      <div className={`${starChipClass} text-green-300`} onClick={() => openHandler(3)}>
                        <StarOutlineIcon className="!text-4xl cursor-pointer transition-transform duration-200 group-hover:scale-110" />
                        <div className="text-green-600">
                          Better
                        </div>
                      </div>

                      <div className={`${starChipClass} text-green-500`} onClick={() => openHandler(4)}>
                        <StarOutlineIcon className="!text-4xl cursor-pointer transition-transform duration-200 group-hover:scale-110" />
                        <div className="text-green-600">
                          Best
                        </div>
                      </div>

                      <div className={`${starChipClass} text-green-600`} onClick={() => openHandler(5)}>
                        <StarOutlineIcon className="!text-4xl cursor-pointer transition-transform duration-200 group-hover:scale-110" />
                        <div className="text-green-600">
                          Loved it
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {page === 2 && (
            <div className="qs-fade-in space-y-8">
              <div className="space-y-3">
                <div className="qs-title flex justify-center">
                  How was your experience?
                </div>
                <div className="qs-subtitle flex justify-center">
                  Thank you for choosing us! Please take a moment to leave us a review. Your responses will help us serve you better in the future.
                </div>
              </div>
              <div className="space-y-3">
                <div className="flex justify-center">
                  {experienceGetData?.review_site_1_url !== null && (
                    <button
                      className="qs-btn"
                      type="button"
                      style={{
                        backgroundColor: '#4CAF50',
                        color: '#FFFFFF',
                      }}
                      onClick={() => handleReviewActivity(experienceGetData?.review_site_1_platform,'google_type')}
                    >
                      <a href={experienceGetData?.review_site_1_url}>
                        <div className="flex items-center justify-center gap-3">
                          <img
                            src={google}
                            alt={experienceGetData?.review_site_1_platform}
                            className="h-8 w-8 rounded-lg bg-white object-contain p-1"
                          />
                          <span className="text-[15px]">
                            Review us on Google
                          </span>
                        </div>
                      </a>
                    </button>
                  )}
                </div>
          
                <div className="flex justify-center">
                  {experienceGetData?.review_site_2_url !== null && (
                    <button
                      className="qs-btn"
                      type="button"
                      style={{
                        backgroundColor: '#4CAF50',
                        color: '#FFFFFF',
                      }}
                      onClick={() => handleReviewActivity(experienceGetData?.review_site_2_platform,'facebook_type')}
                    >
                      <a href={experienceGetData?.review_site_2_url}>
                        <div className="flex items-center justify-center gap-3">
                          <img
                            src={facebook}
                            alt={experienceGetData?.review_site_2_platform}
                            className="h-8 w-8 rounded-lg bg-white object-contain p-1"
                          />
                          <span className="text-base sm:text-lg">
                            Review us on Facebook
                          </span>
                        </div>
                      </a>
                    </button>
                  )}
                </div>
                <div className="flex justify-center">
                  {experienceGetData?.review_site_3_url !== null && (
                    <button
                      className="qs-btn"
                      type="button"
                      style={{
                        backgroundColor: '#4CAF50',
                        color: '#FFFFFF',
                      }}
                      onClick={() => handleReviewActivity(experienceGetData?.review_site_3_platform,'yelp_type')}
                    >
                      <a href={experienceGetData?.review_site_3_url}>
                        <div className="flex items-center justify-center gap-3">
                          <img
                            src="data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'%3e%3crect width='512' height='512' style='fill:%23d32323'/%3e%3cpath d='M248.32,74.24c-1.28-4.69-5.12-8.11-10.24-9.81-16.21-4.27-79.36,13.65-90.88,26-3.84,3.84-5.12,9-3.84,13.23,1.71,3.84,79.79,128.43,79.79,128.43,11.52,18.77,20.9,16.21,23.89,14.93,3-.85,12.37-3.84,11.52-26C256.85,195,249.17,79.79,248.32,74.24ZM214.61,308.05c6.4-1.7,10.67-7.68,11.1-14.93.42-7.68-3.42-14.51-9.82-17.07L198,268.8c-61-25.6-63.57-26.45-66.56-26.45-4.69-.43-9,2.13-11.94,6.82-6,9.82-8.54,41.39-6.4,62.3.85,6.82,2.13,12.8,3.84,16.21,2.56,4.69,6.4,7.68,11.09,7.68,3,0,4.69-.43,61.44-18.77Zm32,23.47c-6.82-3-14.5-1.28-18.77,4.27l-12.37,14.93c-42.67,51.2-44.38,53.33-45.66,56.32a12.66,12.66,0,0,0-.85,5.55,11.5,11.5,0,0,0,3.41,7.68c9.82,11.94,57.18,29.86,72.54,27.3A13.06,13.06,0,0,0,255.57,439c.86-3,1.28-5.12,1.28-65.28V346.45C257.71,340.05,253.44,334.08,246.61,331.52Zm148.48,12c-2.56-1.71-4.26-2.56-61-21.34,0,0-24.75-8.53-25.17-8.53-6-2.56-12.8-.43-17.5,5.55s-5.54,13.65-1.7,19.62l9.81,16.64c33.71,55.47,36.27,59.31,38.4,61.44,3.84,3,8.53,3.42,13.65,1.28,14.51-6,45.66-46.08,47.79-61.86C400.21,351.15,398.93,346.45,395.09,343.47Zm-91.3-63.15c9-1.71,82.34-19.2,88.32-23.47,3.84-2.56,6-7.25,5.54-12.8v-.42c-1.7-16.22-29.44-58-43.09-64.86-4.69-2.13-9.81-2.13-13.65.43-2.56,1.71-4.27,4.27-38.83,52.05L286.29,253c-4.26,5.12-4.26,12.38,0,18.78C290.56,278.61,294.83,282,303.79,280.32Z' style='fill:%23fff'/%3e%3c/svg%3e"
                            alt={experienceGetData?.template?.review_site_3_platform}
                            className="h-8 w-8 rounded-lg object-contain"
                          />
                          <span className="text-base sm:text-lg">
                            Review us on Yelp
                          </span>
                        </div>
                      </a>
                    </button>
                  )}
                </div>
          
              </div>
            </div>
          )}
          {page === 3 && (
            <div className="qs-fade-in space-y-4">
              <div className="qs-title flex justify-center">
                <p>Sorry to hear that! Please tell us about your experience below.</p>
              </div>
              <div className="flex-col">
                <p className="qs-label flex">Name</p>
                <textarea
                  className="qs-input flex h-12 resize-none overflow-y-hidden"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="flex-col">
                <p className="qs-label flex">Phone Number</p>
                <textarea
                  className="qs-input flex h-12 resize-none overflow-y-hidden"
                  value={number}
                  onKeyPress={(e) => {
                    const validKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
                    if (!validKeys.includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  maxLength={10}
                  onChange={(e) => setphoneNuumber(e.target.value)}
                />
              </div>
              <div className="flex-col">
                <p className="qs-label flex">Message</p>
                <textarea
                  className="qs-input flex min-h-[120px] resize-y"
                  placeholder="Tell us about your experience"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>
              <div className="flex justify-center pt-2">
                <button
                  type="button"
                  disabled={message?.length < 4 || name?.length < 2 || number?.length < 10 || loading}
                  className="qs-btn qs-btn-primary sm:w-1/2"
                  onClick={SendReview}
                >
                  Submit
                </button>
              </div>
            </div>
          )}
          {page === 4 && (
            <div className="qs-fade-in flex min-h-[300px] flex-col justify-center space-y-4 py-6">        
              <div className="qs-success-icon">
                <img src={righticon} alt="tick mark" className="h-12 w-12 object-contain" />
              </div>
              <div className="qs-title flex justify-center pt-2">
                Thanks!
              </div>
              <div className="qs-subtitle">
                Thanks for letting us know, we value your feedback.            
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CustomerExperience;
